import 'slick-carousel';

/**
 * Slider Handler Module
 * Initializes gallery sliders
 */

const handleSlider = () => {
	$('.js-slider-gallery').each((idx, domNode) => {
		const $this = $(domNode);
		const $prevArrow = $this.find('.js-slider-arrow-prev');
		const $nextArrow = $this.find('.js-slider-arrow-next');

		$this.find('.slider__slides').slick({
			infinite: true,
			slidesToShow: 1,
			slidesToScroll: 1,
			arrows: true,
			prevArrow: $prevArrow,
			nextArrow: $nextArrow,
		});
	});
};

export default handleSlider;
